<template>
    <div class="button outlined" @click="showModal()">続行する</div>
    <div class="form" v-if="show">
        <div class="box" v-click-outside="closeModal">
            <div ref="slider" class="contents keen-slider">
                <div class="confirm">
                    <h3>アカウントを削除しますか？</h3>
                    <p>
                      削除すると復活させることはできません。<br>
                      投稿されたレビュー、写真、コメント等は、アカウントを削除されてもサイト上に残ります。
                    </p>
                    <div class="next">
                        <div class="button" @click="next()">削除する</div>
                        <div class="button outlined" @click="closeModal">キャンセル</div>
                    </div>
                </div>
                <div class="complete">
                    <div class="icon"></div>
                    <h3>アカウントを削除しました</h3>
                    <p>
                        退会完了メールを送信しました。<br>
                        今までALOCOをご利用いただき、誠にありがとうございました。<br>
                        またのご利用を心よりお待ちしております。
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vClickOutside from 'click-outside-vue3'
import KeenSlider from 'keen-slider';
export default {
    props: {
        shop: Object
    },
    data() {
        return {
            show: false,
            slide: null,
            index: 0,
        }
    },
    mounted() {
        const content = document.querySelector('.accounts')
        if (content) {
            this.initSlide()
        }
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    methods: {
        showModal() {
            this.show = true;
        },
        closeModal() {
            this.show = false;
        },
        initSlide() {
            const sliderUl = this.$refs.slider
            if (!sliderUl) return
            const childrenArray = Array.from(sliderUl.children)
            this.slide = KeenSlider(this.$refs.slider, {
                initial: this.index,
                drag: false,
                slides: {
                    perView: 1
                },
                selector: childrenArray
            })
            this.slide.on('slideChanged', (instance) => {
                const current = instance.track.details.abs
                this.index = current
            })
        },
        async next() {
          await this.delete()
        },
        prev(number) {
            this.slide.prev('slideChanged', () => {
                this.index = number
            })
        },
        async delete(number) {
          // アカウント削除API
            await axios.post('/api/users/account/delete', this.params).then(res => {
                if (res.data.success) {
                    this.slide.next('slideChanged', () => {
                        this.index = number
                    })
                    setTimeout(function() {
                        window.location.href = '/'
                    },2000);

                } else {
                    console.log(res.data.errors)
                    this.errors = res.data.errors
                }
            }).catch(e => {
              console.log('Error', e)
            });
        }
    },
    watch: {
        show(val) {
            if (!val) return
            this.$nextTick(() => {
                this.initSlide(val)
            })
        }
    }
}
</script>
